import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { DialogDefaultV2, InputV2 } from '../../../components/v2';

const schema = {
  motivo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const InvalidarDialog = ({ open, feriado, onClose, onConfirm }) => {
  const [motivo, setMotivo] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setMotivo('');
      setErrors({});
    }
  }, [open]);

  const handleConfirm = () => {
    const erros = validate({ motivo }, schema);
    setErrors(erros || {});
    if (!erros) {
      onConfirm(motivo);
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title={`Invalidar feriado${feriado?.nome ? ` — ${feriado.nome}` : ''}`}
      confirmMessage="Invalidar"
      maxWidth="sm"
      fullWidth
    >
      <InputV2
        error={!!(errors && errors.motivo)}
        isRequired
        label="Motivo"
        name="motivo"
        onChange={(e) => setMotivo(e.target.value)}
        value={motivo}
        rows={3}
        multiline
        placeholder="Ex.: Decreto Municipal 123/2026 revogou o feriado"
      />
    </DialogDefaultV2>
  );
};

InvalidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  feriado: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

InvalidarDialog.defaultProps = {
  feriado: null,
};

export default InvalidarDialog;
